export default __webpack_public_path__ + "static/media/animation-arrow26.1f42535f.gif";